// Value lists of Opportunities 2c. They must equal the server's (server/models/opportunityModel.js),
// in the same order; the server matches them exactly.

export const STATUSES = ["Business Lead", "Qualified", "Staffing", "Proposal", "Won", "Lost"];
// Shown on the dashboard's Active Opportunities card: every status except Lost.
export const ACTIVE_STATUSES = STATUSES.filter((s) => s !== "Lost");

export const FIXED_TERM = "Fixed Term Project";
export const ENGAGEMENT_DURATIONS = [FIXED_TERM, "Existing Engagement", "Ongoing Engagement"];

export const DELIVERY_MODELS = ["Individual Consultant", "Customer-Managed Team", "Managed Team", "Managed Service", "Project Delivery"];

// Descriptions as the ticket and the Figma "Service type" popup word them.
export const SERVICE_TYPE_OPTIONS = [
  { name: "Development", description: "Building new applications, products or functionality" },
  { name: "Maintenance & Support", description: "Maintaining, supporting and improving existing systems" },
  { name: "Operations & Infrastructure", description: "Running infrastructure, cloud environments and IT operations" },
  { name: "Consulting & Advisory", description: "Specialist expertise, strategy and advisory services" },
  { name: "Transformation & Migration", description: "Modernization, migrations and organizational or technical change" },
  { name: "Quality Assurance & Testing", description: "Testing, validation and quality assurance" },
  { name: "Design & UX", description: "User experience, product design and research" },
  { name: "Other", description: "Other types of engagements" },
];
export const SERVICE_TYPES = SERVICE_TYPE_OPTIONS.map((o) => o.name);

// Service types are always kept and shown in the popup's order, whatever the click order.
export const inServiceTypeOrder = (types) => SERVICE_TYPES.filter((t) => (types || []).includes(t));
